import React, { useEffect, useState } from "react";
import {
    listjoballocations,
    createjoballocation,
    viewjoballocation,
    updateverification,
    approveallocation,
    rejectallocation,
    updateallocationstatus,
    deletejoballocation,
    getstafflist,
    memberlist
} from "../../../services/admin";
import { toast } from "react-toastify";
import moment from "moment";
import Swal from "sweetalert2";
import Select from "react-select";

export default function JobAllocation() {
    const [allocations, setAllocations] = useState([]);
    const [members, setMembers] = useState([]);
    const [staff, setStaff] = useState([]);
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('list');
    const [selectedAllocation, setSelectedAllocation] = useState(null);
    const userRole = localStorage.getItem("Role");

    // Form Data
    const [formData, setFormData] = useState({
        member_id: "",
        assigned_to: "",
        task_type: "New Loan Process",
        task_description: "",
        member_location: "",
        due_date: "",
        priority: "Medium",
        document_file: null
    });

    // react-select states
    const [selectedMember, setSelectedMember] = useState(null);
    const [selectedStaff, setSelectedStaff] = useState(null);

    // Verification Form Data
    const [verificationData, setVerificationData] = useState({
        location_verified: false,
        verification_notes: "",
        member_location_latitude: "",
        member_location_longitude: "",
        employee_location_latitude: "",
        employee_location_longitude: ""
    });

    // Admin Notes Data
    const [adminNotesData, setAdminNotesData] = useState({
        admin_notes: ""
    });

    // Filters
    const [filters, setFilters] = useState({
        status: "",
        priority: "",
        assigned_to: ""
    });

    useEffect(() => {
        fetchAllocations();
        fetchMembers();
        if (userRole == 1 || userRole == 2) {
            fetchStaff();
        }
    }, []);

    const fetchAllocations = (filterParams = {}) => {
        setLoading(true);
        const params = { ...filters, ...filterParams };
        listjoballocations(params).then((res) => {
            if (res.status === true) {
                setAllocations(res.data);
            }
            setLoading(false);
        });
    };

    const fetchMembers = () => {
        const branchId = localStorage.getItem("branch") || "";
        const formData = new FormData();
        formData.append("branch", branchId);

        memberlist(formData).then((res) => {
            if (res.status === true) {
                setMembers(res.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching members:", error);
            setMembers([]);
        });
    };

    const fetchStaff = () => {
        getstafflist().then((res) => {
            if (res.status === true) {
                setStaff(res.data);
            }
        });
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        if (type === 'file') {
            setFormData(prev => ({ ...prev, [name]: files[0] }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleMemberChange = (selected) => {
        setSelectedMember(selected);
        setFormData(prev => ({ ...prev, member_id: selected ? selected.value : "" }));
    };

    const handleStaffChange = (selected) => {
        setSelectedStaff(selected);
        setFormData(prev => ({ ...prev, assigned_to: selected ? selected.value : "" }));
    };

    const getMemberLocationForVerification = () => {
        if (navigator.geolocation) {
            toast.info("Capturing member's location...");
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setVerificationData(prev => ({
                        ...prev,
                        member_location_latitude: position.coords.latitude.toString(),
                        member_location_longitude: position.coords.longitude.toString()
                    }));
                    toast.success("Member location captured successfully");
                },
                (error) => {
                    toast.error("Failed to get location: " + error.message);
                }
            );
        } else {
            toast.error("Geolocation is not supported by this browser");
        }
    };

    const getEmployeeLocation = () => {
        if (navigator.geolocation) {
            toast.info("Capturing your location...");
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setVerificationData(prev => ({
                        ...prev,
                        employee_location_latitude: position.coords.latitude.toString(),
                        employee_location_longitude: position.coords.longitude.toString()
                    }));
                    toast.success("Your location captured successfully");
                },
                (error) => {
                    toast.error("Failed to get location: " + error.message);
                }
            );
        } else {
            toast.error("Geolocation is not supported by this browser");
        }
    };

    const handleVerificationChange = (e) => {
        const { name, value, type, checked } = e.target;
        setVerificationData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleAdminNotesChange = (e) => {
        const { name, value } = e.target;
        setAdminNotesData(prev => ({ ...prev, [name]: value }));
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        const newFilters = { ...filters, [name]: value };
        setFilters(newFilters);
        fetchAllocations(newFilters);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.member_id || !formData.assigned_to) {
            toast.error("Please select member and staff");
            return;
        }

        // Create FormData for file upload
        const submitData = new FormData();
        submitData.append('member_id', formData.member_id);
        submitData.append('assigned_to', formData.assigned_to);
        submitData.append('task_type', formData.task_type);
        submitData.append('task_description', formData.task_description);
        submitData.append('member_location', formData.member_location);
        submitData.append('due_date', formData.due_date);
        submitData.append('priority', formData.priority);
        if (formData.document_file) {
            submitData.append('document_file', formData.document_file);
        }

        createjoballocation(submitData).then((res) => {
            if (res.status === true) {
                toast.success("Job Allocated Successfully");
                fetchAllocations();
                resetForm();
                setActiveTab('list');
            } else {
                toast.error(res.message || "Failed to allocate job");
            }
        });
    };

    const handleVerificationSubmit = (e) => {
        e.preventDefault();

        if (!verificationData.verification_notes) {
            toast.error("Please add verification notes");
            return;
        }

        if (!verificationData.member_location_latitude || !verificationData.member_location_longitude) {
            toast.error("Please capture member's location");
            return;
        }

        if (!verificationData.employee_location_latitude || !verificationData.employee_location_longitude) {
            toast.error("Please capture your current location");
            return;
        }

        updateverification(selectedAllocation.id, verificationData).then((res) => {
            if (res.status === true) {
                toast.success("Verification Updated Successfully");
                fetchAllocations();
                setActiveTab('list');
                setSelectedAllocation(null);
            } else {
                toast.error(res.message || "Failed to update verification");
            }
        });
    };

    const handleApprove = (allocation) => {
        Swal.fire({
            title: 'Approve Allocation?',
            text: `Approve work for ${allocation.member?.name}?`,
            icon: 'question',
            input: 'textarea',
            inputLabel: 'Admin Notes (Optional)',
            inputPlaceholder: 'Enter any notes...',
            showCancelButton: true,
            confirmButtonColor: '#28a745',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Approve'
        }).then((result) => {
            if (result.isConfirmed) {
                approveallocation(allocation.id, { admin_notes: result.value }).then((res) => {
                    if (res.status === true) {
                        toast.success("Job Allocation Approved Successfully");
                        fetchAllocations();
                    } else {
                        toast.error(res.message || "Failed to approve");
                    }
                });
            }
        });
    };

    const handleReject = (allocation) => {
        Swal.fire({
            title: 'Reject Allocation?',
            text: `Reject work for ${allocation.member?.name}?`,
            icon: 'warning',
            input: 'textarea',
            inputLabel: 'Reason for Rejection',
            inputPlaceholder: 'Enter reason...',
            inputValidator: (value) => {
                if (!value) {
                    return 'Reason is required!'
                }
            },
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Reject'
        }).then((result) => {
            if (result.isConfirmed) {
                rejectallocation(allocation.id, { admin_notes: result.value }).then((res) => {
                    if (res.status === true) {
                        toast.success("Job Allocation Rejected");
                        fetchAllocations();
                    } else {
                        toast.error(res.message || "Failed to reject");
                    }
                });
            }
        });
    };

    const handleStartWork = (allocation) => {
        updateallocationstatus(allocation.id, { status: 'In Progress' }).then((res) => {
            if (res.status === true) {
                toast.success("Work Started");
                fetchAllocations();
            } else {
                toast.error(res.message || "Failed to update status");
            }
        });
    };

    const handleVerify = (allocation) => {
        setSelectedAllocation(allocation);
        setVerificationData({
            location_verified: false,
            verification_notes: "",
            member_location_latitude: "",
            member_location_longitude: "",
            employee_location_latitude: "",
            employee_location_longitude: ""
        });
        setActiveTab('verify');
    };

    const handleDelete = (allocation) => {
        Swal.fire({
            title: 'Delete Job Allocation?',
            text: `Delete allocation for ${allocation.member?.name}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Delete'
        }).then((result) => {
            if (result.isConfirmed) {
                deletejoballocation(allocation.id).then((res) => {
                    if (res.status === true) {
                        toast.success("Job Allocation Deleted");
                        fetchAllocations();
                    } else {
                        toast.error(res.message || "Failed to delete");
                    }
                });
            }
        });
    };

    const resetForm = () => {
        setFormData({
            member_id: "",
            assigned_to: "",
            task_type: "New Loan Process",
            task_description: "",
            member_location: "",
            due_date: "",
            priority: "Medium",
            document_file: null
        });
        setSelectedMember(null);
        setSelectedStaff(null);
        // Reset file input
        const fileInput = document.querySelector('input[name="document_file"]');
        if (fileInput) fileInput.value = '';
    };

    const getStatusBadge = (status) => {
        const badges = {
            'Pending': 'bg-warning',
            'In Progress': 'bg-info',
            'Verified': 'bg-primary',
            'Approved': 'bg-success',
            'Rejected': 'bg-danger'
        };
        return <span className={`badge ${badges[status] || 'bg-secondary'}`}>{status}</span>;
    };

    const getPriorityBadge = (priority) => {
        const badges = {
            'Low': 'bg-secondary',
            'Medium': 'bg-info',
            'High': 'bg-danger'
        };
        return <span className={`badge ${badges[priority] || 'bg-secondary'}`}>{priority}</span>;
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Job Allocation</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Job Allocation
                    </li>
                </ol>
            </div>

            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <h4 className="card-title">Job Allocation Management</h4>
                                        </div>
                                        <div className="col-md-6 text-end">
                                            <button
                                                className={`btn btn-sm ${activeTab === 'list' ? 'btn-primary' : 'btn-outline-primary'} me-1`}
                                                onClick={() => setActiveTab('list')}
                                            >
                                                <i className="fa fa-list"></i> All Tasks
                                            </button>
                                            {(userRole == 1 || userRole == 2) && (
                                                <button
                                                    className={`btn btn-sm ${activeTab === 'create' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => { resetForm(); setActiveTab('create'); }}
                                                >
                                                    <i className="fa fa-plus"></i> Allocate Job
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {/* List Tab */}
                                    {activeTab === 'list' && (
                                        <>
                                            {/* Filters */}
                                            <div className="card mb-3">
                                                <div className="card-body">
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <label className="form-label">Status</label>
                                                            <select
                                                                className="default-select form-control wide"
                                                                name="status"
                                                                value={filters.status}
                                                                onChange={handleFilterChange}
                                                            >
                                                                <option value="">All Status</option>
                                                                <option value="Pending">Pending</option>
                                                                <option value="In Progress">In Progress</option>
                                                                <option value="Verified">Verified</option>
                                                                <option value="Approved">Approved</option>
                                                                <option value="Rejected">Rejected</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <label className="form-label">Priority</label>
                                                            <select
                                                                className="default-select form-control wide"
                                                                name="priority"
                                                                value={filters.priority}
                                                                onChange={handleFilterChange}
                                                            >
                                                                <option value="">All Priority</option>
                                                                <option value="Low">Low</option>
                                                                <option value="Medium">Medium</option>
                                                                <option value="High">High</option>
                                                            </select>
                                                        </div>
                                                        {(userRole == 1 || userRole == 2) && (
                                                            <div className="col-md-3">
                                                                <label className="form-label">Assigned To</label>
                                                                <select
                                                                    className="default-select form-control wide"
                                                                    name="assigned_to"
                                                                    value={filters.assigned_to}
                                                                    onChange={handleFilterChange}
                                                                >
                                                                    <option value="">All Staff</option>
                                                                    {staff.map((s) => (
                                                                        <option key={s.id} value={s.id}>{s.name}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        )}
                                                        <div className="col-md-3">
                                                            <label className="form-label">&nbsp;</label>
                                                            <button
                                                                className="btn btn-secondary w-100"
                                                                onClick={() => {
                                                                    setFilters({ status: "", priority: "", assigned_to: "" });
                                                                    fetchAllocations({});
                                                                }}
                                                            >
                                                                Clear Filters
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Allocations Table */}
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Member</th>
                                                            <th>Task Type</th>
                                                            <th>Assigned To</th>
                                                            <th>Location</th>
                                                            <th>Due Date</th>
                                                            <th className="text-center">Priority</th>
                                                            <th className="text-center">Status</th>
                                                            <th className="text-center">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {allocations.length > 0 ? (
                                                            allocations.map((allocation) => (
                                                                <tr key={allocation.id}>
                                                                    <td>
                                                                        <strong>{allocation.member?.member_name}</strong>
                                                                    </td>
                                                                    <td>{allocation.task_type}</td>
                                                                    <td>{allocation.assigned_to ? allocation.assigned_to?.name : 'Not Assigned'}</td>
                                                                    <td>
                                                                        {allocation.member_location}
                                                                        {allocation.location_verified && (
                                                                            <><br /><span className="badge bg-success">Verified</span></>
                                                                        )}
                                                                    </td>
                                                                    <td>{allocation.due_date ? moment(allocation.due_date).format('DD-MM-YYYY') : '-'}</td>
                                                                    <td className="text-center">{getPriorityBadge(allocation.priority)}</td>
                                                                    <td className="text-center">{getStatusBadge(allocation.status)}</td>
                                                                    <td className="text-center">
                                                                        {/* Staff Actions */}
                                                                        {allocation.status === 'Pending' && allocation.assigned_to?.id == localStorage.getItem('UID') && (
                                                                            <button
                                                                                className="btn btn-sm btn-primary me-1"
                                                                                onClick={() => handleStartWork(allocation)}
                                                                                title="Start Work"
                                                                            >
                                                                                <i className="fa fa-play"></i>
                                                                            </button>
                                                                        )}
                                                                        {allocation.status === 'In Progress' && allocation.assigned_to?.id == localStorage.getItem('UID') && (
                                                                            <button
                                                                                className="btn btn-sm btn-success me-1"
                                                                                onClick={() => handleVerify(allocation)}
                                                                                title="Submit Verification"
                                                                            >
                                                                                <i className="fa fa-check"></i>
                                                                            </button>
                                                                        )}

                                                                        {/* Admin Actions */}
                                                                        {(userRole == 1 || userRole == 2) && allocation.status === 'Verified' && (
                                                                            <>
                                                                                <button
                                                                                    className="btn btn-sm btn-success me-1"
                                                                                    onClick={() => handleApprove(allocation)}
                                                                                    title="Approve"
                                                                                >
                                                                                    <i className="fa fa-thumbs-up"></i>
                                                                                </button>
                                                                                <button
                                                                                    className="btn btn-sm btn-danger me-1"
                                                                                    onClick={() => handleReject(allocation)}
                                                                                    title="Reject"
                                                                                >
                                                                                    <i className="fa fa-thumbs-down"></i>
                                                                                </button>
                                                                            </>
                                                                        )}

                                                                        {(userRole == 1 || userRole == 2) && allocation.status === 'Pending' && (
                                                                            <button
                                                                                className="btn btn-sm btn-danger"
                                                                                onClick={() => handleDelete(allocation)}
                                                                                title="Delete"
                                                                            >
                                                                                <i className="fa fa-trash"></i>
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="8" className="text-center text-muted">
                                                                    {loading ? 'Loading...' : 'No job allocations found.'}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )}

                                    {/* Create Tab - Role 1 or 2 only */}
                                    {activeTab === 'create' && (userRole == 1 || userRole == 2) && (
                                        <div className="card">
                                            <div className="card-header">
                                                <h5>Allocate New Job</h5>
                                            </div>
                                            <div className="card-body">
                                                <form onSubmit={handleSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Select Member <span className="text-danger">*</span></label>
                                                            <Select
                                                                value={selectedMember}
                                                                onChange={handleMemberChange}
                                                                options={members.map((member) => ({
                                                                    value: member.id,
                                                                    label: `${member.member_name} (${member.group_name ? '' + member.group_name : ''})`
                                                                }))}
                                                                placeholder="Select Member"
                                                                isClearable
                                                                required
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Assign To Staff <span className="text-danger">*</span></label>
                                                            <Select
                                                                value={selectedStaff}
                                                                onChange={handleStaffChange}
                                                                options={staff.map((s) => ({
                                                                    value: s.id,
                                                                    label: s.name
                                                                }))}
                                                                placeholder="Select Staff"
                                                                isClearable
                                                                required
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Task Type</label>
                                                            <select
                                                                className="default-select form-control wide"
                                                                name="task_type"
                                                                value={formData.task_type}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="New Loan Process">New Loan Process</option>
                                                                <option value="Loan Renewal">Loan Renewal</option>
                                                                <option value="Field Verification">Field Verification</option>
                                                                <option value="Document Collection">Document Collection</option>
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Due Date</label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                name="due_date"
                                                                value={formData.due_date}
                                                                onChange={handleInputChange}
                                                            />
                                                        </div>
                                                        <div className="col-md-4 mb-3">
                                                            <label className="form-label">Priority</label>
                                                            <select
                                                                className="default-select form-control wide"
                                                                name="priority"
                                                                value={formData.priority}
                                                                onChange={handleInputChange}
                                                            >
                                                                <option value="Low">Low</option>
                                                                <option value="Medium">Medium</option>
                                                                <option value="High">High</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Member Location</label>
                                                            <textarea
                                                                className="form-control"
                                                                name="member_location"
                                                                value={formData.member_location}
                                                                onChange={handleInputChange}
                                                                rows="3"
                                                                placeholder="Enter member's address/location details"
                                                            ></textarea>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Task Description</label>
                                                            <textarea
                                                                className="form-control"
                                                                name="task_description"
                                                                value={formData.task_description}
                                                                onChange={handleInputChange}
                                                                rows="3"
                                                                placeholder="Enter task details"
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <label className="form-label">Upload Document (Optional)</label>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                name="document_file"
                                                                onChange={handleInputChange}
                                                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                                            />
                                                            <small className="text-muted">Accepted formats: PDF, DOC, DOCX, JPG, PNG (Max 5MB)</small>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 text-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary me-2"
                                                                onClick={() => { resetForm(); setActiveTab('list'); }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button type="submit" className="btn btn-primary">
                                                                <i className="fa fa-save"></i> Allocate Job
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    )}

                                    {/* Verify Tab - Staff only */}
                                    {activeTab === 'verify' && selectedAllocation && (
                                        <div className="card">
                                            <div className="card-header">
                                                <h5>Submit Verification</h5>
                                            </div>
                                            <div className="card-body">
                                                <div className="alert alert-info">
                                                    <strong>Member:</strong> {selectedAllocation.member?.name}<br />
                                                    <strong>Task:</strong> {selectedAllocation.task_type}<br />
                                                    <strong>Location:</strong> {selectedAllocation.member_location}
                                                </div>
                                                <form onSubmit={handleVerificationSubmit}>
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input"
                                                                    name="location_verified"
                                                                    checked={verificationData.location_verified}
                                                                    onChange={handleVerificationChange}
                                                                />
                                                                <label className="form-check-label">
                                                                    Location Verified (I have visited and verified the member's location)
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Capture Member's Location <span className="text-danger">*</span></label>
                                                            <div className="d-flex gap-2 align-items-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary"
                                                                    onClick={getMemberLocationForVerification}
                                                                >
                                                                    <i className="fa fa-map-marker"></i> Get Member Location
                                                                </button>
                                                                {verificationData.member_location_latitude && verificationData.member_location_longitude && (
                                                                    <span className="badge bg-success">
                                                                        Captured: {verificationData.member_location_latitude}, {verificationData.member_location_longitude}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <small className="text-muted">Capture GPS location where member is located</small>
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label">Capture Your Location <span className="text-danger">*</span></label>
                                                            <div className="d-flex gap-2 align-items-center">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-info"
                                                                    onClick={getEmployeeLocation}
                                                                >
                                                                    <i className="fa fa-user-circle"></i> Get My Location
                                                                </button>
                                                                {verificationData.employee_location_latitude && verificationData.employee_location_longitude && (
                                                                    <span className="badge bg-success">
                                                                        Captured: {verificationData.employee_location_latitude}, {verificationData.employee_location_longitude}
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <small className="text-muted">Capture your current GPS location</small>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 mb-3">
                                                            <label className="form-label">Verification Notes <span className="text-danger">*</span></label>
                                                            <textarea
                                                                className="form-control"
                                                                name="verification_notes"
                                                                value={verificationData.verification_notes}
                                                                onChange={handleVerificationChange}
                                                                rows="4"
                                                                placeholder="Enter your verification findings, observations, and recommendations..."
                                                                required
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-12 text-end">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary me-2"
                                                                onClick={() => { setActiveTab('list'); setSelectedAllocation(null); }}
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button type="submit" className="btn btn-success">
                                                                <i className="fa fa-check"></i> Submit Verification
                                                            </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
